import styled from 'styled-components/macro';

export const Wrapper = styled.div<{ collapsed: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-height: ${(props) => (props.collapsed ? '220px' : '5764px')};
  transition: all 150ms ease-out;
`;

export const ToggleWrapper = styled.div`
  position: absolute;
  top: 10px;
  left: -35px;
`;
